import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

// Import all images
import servicesBg from '../../assets/img/services/vs-services-style1-bg.png';
import cloudIcon from '../../assets/img/icons/cloud.png';
import ballonIcon from '../../assets/img/icons/ballon.png';
import serviceThumb1 from '../../assets/img/services/services-thumb-1-3.png';
import serviceThumb2 from '../../assets/img/services/services-thumb-1-4.png';
import serviceThumb3 from '../../assets/img/services/services-thumb-1-1.png';
import serviceThumb4 from '../../assets/img/services/services-thumb-1-2.png';
import avatarsImg from '../../assets/img/services/vs-services-box-style1-v2-avatars.png';
import eiffelTower from '../../assets/img/icons/eiffel-tower.png';

const Services = () => {
    const services = [
        {
            id: 1,
            image: serviceThumb1,
            title: "Support 24/7",
            description: "Lorem ipsum dolor sits ameter consecte adipiscing"
        },
        {
            id: 2,
            image: serviceThumb2,
            title: "Fast Booking",
            description: "Lorem ipsum dolor sits ameter consecte adipiscing"
        },
        {
            id: 3,
            image: serviceThumb3,
            title: "Adventures",
            description: "Lorem ipsum dolor sits ameter consecte adipiscing"
        },
        {
            id: 4,
            image: serviceThumb4,
            title: "Travel Guide",
            description: "Lorem ipsum dolor sits ameter consecte adipiscing"
        }
    ];

    const subtitleRef = useRef(null);
    const titleRef = useRef(null);
    const serviceRefs = useRef([]);
    const featureTitleRef = useRef(null);
    const buttonRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('visible');
                    }
                });
            },
            { threshold: 0.1 }
        );

        if (titleRef.current) observer.observe(titleRef.current);
        if (subtitleRef.current) observer.observe(subtitleRef.current);
        if (featureTitleRef.current) observer.observe(featureTitleRef.current);
        if (buttonRef.current) observer.observe(buttonRef.current);

        serviceRefs.current.forEach(ref => {
            if (ref) observer.observe(ref);
        });

        return () => observer.disconnect();
    }, []);

    const addToRefs = (el) => {
        if (el && !serviceRefs.current.includes(el)) {
            serviceRefs.current.push(el);
        }
    };

    const ServiceIcon = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="104"
            height="81"
            viewBox="0 0 104 81"
            fill="none"
        >
            <path
                d="M89.0195 24.7886L89.9354 26.6204C92.908 32.5655 97.7287 37.3862 103.674 40.3587H89.0195V24.7886Z"
                fill="white"
            />
            <path
                d="M14.8281 24.7886L13.9122 26.6204C10.9397 32.5655 6.11901 37.3862 0.173851 40.3587H14.8281V24.7886Z"
                fill="white"
            />
            <circle
                cx="40.1642"
                cy="40.1642"
                r="36.1642"
                transform="matrix(1 0 0 -1 11.7588 80.3286)"
                fill="white"
                stroke="white"
                strokeWidth="8"
            />
            <circle
                cx="53.1844"
                cy="40.452"
                r="30.9969"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeDasharray="3 3"
            />
            <path
                d="M63.4074 41.097C64.0732 41.097 64.7131 40.9046 65.2774 40.5259C66.2128 39.8936 66.8621 38.7466 66.8873 37.5539C66.9164 36.9476 66.8873 36.3054 66.7988 35.5899C66.7489 35.1805 66.3883 34.8634 65.9237 34.9095C65.1296 35.0117 64.3158 35.3886 63.6374 35.9788C63.6055 35.7147 63.5632 35.4526 63.5107 35.1926C64.2634 34.8198 64.8452 34.2211 65.1461 33.4738C65.5821 32.4277 65.4454 31.1357 64.788 30.1017C64.4222 29.5252 64.0282 28.996 63.6181 28.5272C63.3333 28.2026 62.8416 28.169 62.5155 28.4539C61.8084 29.0717 61.3319 29.9681 61.1372 31.054C60.9612 32.0962 61.0981 32.975 61.4919 33.9272C63.1284 37.8152 61.6255 42.2608 58.221 44.4323C57.98 44.5827 57.7896 44.7906 57.6592 45.0326H54.3349V41.8382L57.087 43.2671C57.356 43.4061 57.6732 43.3761 57.9071 43.2052C58.1468 43.0311 58.2675 42.7372 58.2187 42.4447L57.5658 38.5166L60.4026 35.7226C60.6134 35.5149 60.6889 35.2056 60.5973 34.9246C60.5057 34.6428 60.2628 34.4367 59.9704 34.3924L56.0516 33.8023L54.2655 29.8536C54.012 29.2932 53.0941 29.2932 52.8406 29.8536L51.0545 33.8023L47.1356 34.3925C46.8432 34.4368 46.6003 34.643 46.5087 34.9248C46.4171 35.2058 46.4927 35.515 46.7034 35.7227L49.5402 38.5168L48.8874 42.4448C48.8385 42.7373 48.9591 43.0313 49.1989 43.2054C49.4387 43.3795 49.7548 43.4032 50.019 43.2673L52.7711 41.8383V45.0327H49.4223C49.1327 44.5473 48.6903 44.3272 48.2759 44.0033C46.0797 42.2272 44.967 39.6693 44.967 37.2133C44.967 34.0911 46.4084 33.5954 45.9819 31.0449C45.7872 29.9674 45.3114 29.0717 44.6051 28.454C44.2821 28.1699 43.7857 28.202 43.5024 28.5273C43.0893 28.9992 42.6953 29.5291 42.3326 30.1011C41.6752 31.135 41.5369 32.427 41.9699 33.4655C42.2739 34.2197 42.8571 34.82 43.6105 35.1932C43.5579 35.4533 43.5158 35.7156 43.4838 35.9799C42.8032 35.3887 41.9754 35.0117 41.1821 34.9095C40.976 34.8874 40.7667 34.9401 40.6026 35.0684C40.4384 35.1959 40.3315 35.3845 40.307 35.5907C40.2192 36.307 40.191 36.9499 40.2177 37.541C40.2505 38.7772 40.9229 39.9272 41.85 40.532C42.3929 40.9062 43.0351 41.0978 43.7063 41.0978C43.8628 41.0978 44.0218 41.0789 44.1807 41.0579C44.2797 41.2995 44.3788 41.5405 44.4957 41.7739C43.7922 41.683 42.9123 41.7052 42.0508 42.1325C41.6534 42.3296 41.5024 42.8133 41.7056 43.1978C41.9798 43.7193 42.3066 44.3218 42.6952 44.8479C43.3576 45.8148 44.447 46.4798 45.7336 46.4798C46.512 46.4798 47.2603 46.1815 47.8777 45.6461C47.9735 45.7145 48.0635 45.7817 48.0794 45.8147V51.2882H47.2975C46.8653 51.2882 46.5156 51.638 46.5156 52.0702C46.5156 52.5024 46.8653 52.8521 47.2975 52.8521H59.8084C60.2406 52.8521 60.5904 52.5024 60.5904 52.0702C60.5904 51.638 60.2406 51.2882 59.8084 51.2882H59.0265V45.8987C59.0359 45.8502 59.0563 45.8047 59.0563 45.7543C59.1173 45.7153 59.17 45.6675 59.2299 45.6275C60.8568 47.0626 63.1599 46.6219 64.4435 44.8525C64.8103 44.2942 65.1681 43.7628 65.4446 43.1626C65.6218 42.7786 65.4607 42.3227 65.0811 42.1348C64.3675 41.7814 63.5574 41.6776 62.622 41.7924C62.7432 41.5518 62.8627 41.3101 62.9644 41.0599C63.1128 41.0785 63.2611 41.097 63.4074 41.097ZM55.1169 49.7243H51.9891C51.5569 49.7243 51.2072 49.3745 51.2072 48.9423C51.2072 48.5101 51.5569 48.1604 51.9891 48.1604H55.1169C55.5491 48.1604 55.8988 48.5101 55.8988 48.9423C55.8988 49.3745 55.5491 49.7243 55.1169 49.7243Z"
                fill="white"
            />
        </svg>
    );

    return (
        <>
            <div
                className="vs-feature-style1 position-relative bg-theme-color"
                style={{
                    backgroundColor: 'rgb(226 126 13)',
                    padding: '60px 0',
                    position: 'relative',
                    overflow: 'hidden'
                }}
            >
                <div className="container" style={{ position: 'relative', zIndex: 2 }}>
                    <div className="row g-4 align-items-center">
                        <div className="col-md-7 mt-md-0">
                            <h3
                                ref={featureTitleRef}
                                className="feature-expert text-white-color ff-rubik fw-bold text-center text-md-start char-animation fade-anim"
                                style={{
                                    fontSize: '32px',
                                    fontWeight: '700',
                                    margin: 0,
                                    color: '#ffffff'
                                }}
                            >
                                Need tour Expert ?
                            </h3>
                        </div>
                        <div
                            className="col-md-5 mt-md-0 d-flex justify-content-center justify-content-md-end"
                        >
                            <Link
                                to="/about"
                                className="vs-btn style-4"
                                style={{
                                    display: 'inline-block',
                                    backgroundColor: '#ffffff',
                                    color: '#fff',
                                    padding: '20px 30px',
                                    borderRadius: '20px',
                                    textDecoration: 'none',
                                    fontWeight: '600',
                                    textTransform: 'uppercase',
                                    letterSpacing: '1px',
                                    transition: 'all 0.3s ease',
                                    fontSize: '14px',
                                    border: 'none',
                                    cursor: 'pointer',
                                    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.2)'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'translateY(-3px)';
                                    e.target.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.3)';
                                    e.target.style.backgroundColor = '#f8f9fa';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.2)';
                                    e.target.style.backgroundColor = '#ffffff';
                                }}
                            >
                                Visit Our plan
                            </Link>
                        </div>
                    </div>
                </div>
                <h2
                    className="position-absolute text-white-color"
                    style={{
                        position: 'absolute',
                        bottom: '-50px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        fontSize: '250px',
                        fontWeight: '900',
                        color: 'rgba(255, 255, 255, 0.1)',
                        margin: 0,
                        zIndex: 1,
                        whiteSpace: 'nowrap'
                    }}
                >
                    Adventures
                </h2>
            </div>

            {/* Services Area */}
            <section
                className="vs-services-style1 space"
                style={{
                    background: `linear-gradient(rgba(36, 56, 103, 0.89), rgba(36, 56, 103, 0.89)), url(${servicesBg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    position: 'relative',
                    overflow: 'hidden',
                    padding: '100px 0'
                }}
            >
                {/* Background Icons */}
                <img
                    src={cloudIcon}
                    alt="icon"
                    className="vs-services-style1-icon-1 animate-parachute"
                    style={{
                        position: 'absolute',
                        top: '20px',
                        left: '5%',
                        zIndex: 1
                    }}
                />
                <img
                    src={ballonIcon}
                    alt="icon"
                    className="vs-services-style1-icon-2 animate-parachute"
                    style={{
                        position: 'absolute',
                        bottom: '10%',
                        right: '5%',
                        zIndex: 1
                    }}
                />

                <div className="container" style={{ position: 'relative', zIndex: 2 }}>
                    <div className="row g-4 align-items-end">
                        <div className="col-md-6 text-center text-md-start">
                            <div className="row">
                                <div className="col-12 col-xl-11">
                                    <div className="title-area text-center text-md-start">
                                        <span
                                            ref={subtitleRef}
                                            className="sec-subtitle fade-anim"
                                            style={{
                                                display: 'block',
                                                color: '#f7921f',
                                                fontSize: '18px',
                                                fontWeight: '600',
                                                textTransform: 'uppercase',
                                                letterSpacing: '2px',
                                                marginBottom: '10px'

                                            }}
                                        >
                                            our services
                                        </span>
                                        <h2
                                            ref={titleRef}
                                            className="sec-title text-white-color fade-anim"
                                            style={{
                                                fontSize: '40px',
                                                fontWeight: '800',
                                                marginBottom: '30px',
                                                lineHeight: '1.3',
                                                color: '#ffffff'
                                            }}
                                        >
                                            It's Time To <span style={{ color: '#f7921f' }}>Travel</span> With Our Company
                                        </h2>
                                    </div>

                                    <div
                                        ref={buttonRef}
                                        className="fade-anim"
                                        style={{
                                            marginTop: '30px',
                                            marginBottom: '40px',
                                            display: 'block',
                                            position: 'relative',
                                            zIndex: 10
                                        }}
                                    >
                                        <Link
                                            to="/services"
                                            className="vs-btn style-4"
                                            style={{
                                                display: 'inline-block',
                                                backgroundColor: '#f7921f',
                                                color: 'white',
                                                padding: '25px 35px',
                                                borderRadius: '25px',
                                                textDecoration: 'none',
                                                fontWeight: '700',
                                                textTransform: 'uppercase',
                                                letterSpacing: '1.5px',
                                                transition: 'all 0.3s ease',
                                                boxShadow: '0 5px 20px rgba(247, 146, 31, 0.4)',
                                                fontSize: '15px',
                                                border: '2px solid #f7921f',
                                                cursor: 'pointer',
                                                fontFamily: 'inherit',
                                                position: 'relative',
                                                zIndex: 100
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.transform = 'translateY(-3px)';
                                                e.target.style.boxShadow = '0 10px 30px rgba(247, 146, 31, 0.6)';
                                                e.target.style.backgroundColor = '#e6831a';
                                                e.target.style.borderColor = '#e6831a';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.transform = 'translateY(0)';
                                                e.target.style.boxShadow = '0 5px 20px rgba(247, 146, 31, 0.4)';
                                                e.target.style.backgroundColor = '#f7921f';
                                                e.target.style.borderColor = '#f7921f';
                                            }}
                                        >
                                            VIEW SERVICE
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            {/* First Two Services */}
                            <div className="row g-4 pt-120">
                                {services.slice(0, 2).map((service, index) => (
                                    <div
                                        key={service.id}
                                        className="col-lg-6 fade-anim"
                                        ref={addToRefs}
                                    >
                                        <div
                                            className="vs-services-box-style1"
                                            style={{
                                                background: 'white',
                                                borderRadius: '20px',
                                                overflow: 'hidden',
                                                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
                                                transition: 'all 0.3s ease',
                                                height: '100%'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-10px)';
                                                e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.15)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.1)';
                                            }}
                                        >
                                            <figure
                                                className="services-thumb"
                                                style={{
                                                    margin: 0,
                                                    overflow: 'hidden'
                                                }}
                                            >
                                                <img
                                                    src={service.image}
                                                    alt={service.title}
                                                    className="w-100"
                                                    style={{
                                                        width: '100%',
                                                        height: '200px',
                                                        objectFit: 'cover',
                                                        display: 'block'
                                                    }}
                                                />
                                            </figure>
                                            <div
                                                className="services-content"
                                                style={{
                                                    padding: '30px',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                <div
                                                    className="services-icon"
                                                    style={{
                                                        color: '#f7921f',
                                                        marginBottom: '20px'
                                                    }}
                                                >
                                                    <ServiceIcon />
                                                </div>
                                                <div className="services-content-inner">
                                                    <h5
                                                        className="services-title"
                                                        style={{
                                                            fontSize: '20px',
                                                            fontWeight: '700',
                                                            marginBottom: '15px',
                                                            color: '#2c3e50'
                                                        }}
                                                    >
                                                        <Link
                                                            to="/Services"
                                                            style={{
                                                                color: 'inherit',
                                                                textDecoration: 'none',
                                                                transition: 'color 0.3s ease'
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.target.style.color = '#f7921f';
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.target.style.color = '#2c3e50';
                                                            }}
                                                        >
                                                            {service.title}
                                                        </Link>
                                                    </h5>
                                                    <p
                                                        className="fs-16 fw-medium"
                                                        style={{
                                                            color: '#666',
                                                            lineHeight: '1.6',
                                                            margin: 0,
                                                            fontSize: '16px',
                                                            fontWeight: '500'
                                                        }}
                                                    >
                                                        {service.description}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/*   Client Feedback */}
                        <div className="col-md-6">
                            <div className="row g-4">
                                {services.slice(2).map((service, index) => (
                                    <div
                                        key={service.id}
                                        className="col-lg-6 fade-anim"
                                        ref={addToRefs}
                                    >
                                        <div
                                            className="vs-services-box-style1"
                                            style={{
                                                background: 'white',
                                                borderRadius: '20px',
                                                overflow: 'hidden',
                                                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
                                                transition: 'all 0.3s ease',
                                                height: '100%'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-10px)';
                                                e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.15)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.1)';
                                            }}
                                        >
                                            <figure
                                                className="services-thumb"
                                                style={{
                                                    margin: 0,
                                                    overflow: 'hidden'
                                                }}
                                            >
                                                <img
                                                    src={service.image}
                                                    alt={service.title}
                                                    className="w-100"
                                                    style={{
                                                        width: '100%',
                                                        height: '200px',
                                                        objectFit: 'cover',
                                                        display: 'block'
                                                    }}
                                                />
                                            </figure>
                                            <div
                                                className="services-content"
                                                style={{
                                                    padding: '30px',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                <div
                                                    className="services-icon"
                                                    style={{
                                                        color: '#f7921f',
                                                        marginBottom: '20px'
                                                    }}
                                                >
                                                    <ServiceIcon />
                                                </div>
                                                <div className="services-content-inner">
                                                    <h5
                                                        className="services-title"
                                                        style={{
                                                            fontSize: '20px',
                                                            fontWeight: '700',
                                                            marginBottom: '15px',
                                                            color: '#2c3e50'
                                                        }}
                                                    >
                                                        <Link
                                                            to="/destination-details"
                                                            style={{
                                                                color: 'inherit',
                                                                textDecoration: 'none',
                                                                transition: 'color 0.3s ease'
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.target.style.color = '#f7921f';
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.target.style.color = '#2c3e50';
                                                            }}
                                                        >
                                                            {service.title}
                                                        </Link>
                                                    </h5>
                                                    <p
                                                        className="fs-16 fw-medium"
                                                        style={{
                                                            color: '#666',
                                                            lineHeight: '1.6',
                                                            margin: 0,
                                                            fontSize: '16px',
                                                            fontWeight: '500'
                                                        }}
                                                    >
                                                        {service.description}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                {/* Client Feedback Card */}
                                <div
                                    className="col-12 fade-anim"
                                    ref={addToRefs}
                                >
                                    <div
                                        className="vs-services-box-style1 v2"
                                        style={{
                                            borderRadius: '20px',
                                            padding: '40px',
                                            position: 'relative',
                                            overflow: 'hidden',
                                            minHeight: '200px'
                                        }}
                                    >
                                        <div className="title-area text-center text-md-start">
                                            <span
                                                className="sec-subtitle text-white-color"
                                                style={{
                                                    display: 'block',
                                                    marginBottom: '10px',
                                                    fontSize: '14px',
                                                    fontWeight: '600',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '1px',
                                                    opacity: '0.9',
                                                    color: '#ffffff'
                                                }}
                                            >
                                                client feedback
                                            </span>
                                            <h4
                                                className="sec-title text-white-color"
                                                style={{
                                                    margin: 0,
                                                    fontSize: '24px',
                                                    fontWeight: '700',
                                                    lineHeight: '1.3',
                                                    color: '#ffffff'
                                                }}
                                            >
                                                It's Time to Travel with our Company
                                            </h4>
                                        </div>
                                        <div
                                            className="services-content d-flex align-items-center gap-3 mt-4"
                                            style={{
                                                alignItems: 'center'
                                            }}
                                        >
                                            <img
                                                src={avatarsImg}
                                                alt="avatars"
                                                style={{
                                                    maxWidth: '80px',
                                                    borderRadius: '10px'
                                                }}
                                            />
                                            <div className="services-info">
                                                <span
                                                    className="fs-16 text-white-color text-uppercase"
                                                    style={{
                                                        display: 'block',
                                                        fontWeight: '600',
                                                        fontSize: '16px',
                                                        color: '#ffffff',
                                                        textTransform: 'uppercase',
                                                        marginBottom: '5px'
                                                    }}
                                                >
                                                    Satisfied Client Rating
                                                </span>
                                                <div className="ratings">
                                                    <ul
                                                        className="custom-ul d-flex"
                                                        style={{
                                                            listStyle: 'none',
                                                            padding: 0,
                                                            margin: 0,
                                                            gap: '5px'
                                                        }}
                                                    >
                                                        {[...Array(5)].map((_, i) => (
                                                            <li key={i}>
                                                                <i
                                                                    className="fa-solid fa-star"
                                                                    style={{
                                                                        color: '#ffd700',
                                                                        fontSize: '16px'
                                                                    }}
                                                                ></i>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <img
                                            src={eiffelTower}
                                            alt="eiffel-tower"
                                            className="eiffel-tower"
                                            style={{
                                                position: 'absolute',
                                                bottom: '0',
                                                right: '20px',
                                                maxHeight: '120px',
                                                opacity: '0.7'
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Add CSS styles in a separate style tag */}
            <style jsx global>{`
                .vs-services-style1 {
                    position: relative;
                }
                
                .fade-anim {
                    opacity: 0;
                    transform: translateY(30px);
                    transition: all 0.6s ease;
                }
                
                .fade-anim.visible {
                    opacity: 1;
                    transform: translateY(0);
                }
                
                .animate-parachute {
                    animation: float 6s ease-in-out infinite;
                }
                
                @keyframes float {
                    0% { transform: translateY(0px); }
                    50% { transform: translateY(-20px); }
                    100% { transform: translateY(0px); }
                }
                
                .text-white-color {
                    color: #ffffff !important;
                    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
                }
                
                .sec-title {
                    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7);
                }
                
                .sec-subtitle {
                    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
                }
                
                .pt-120 {
                    padding-top: 120px;
                }
                
                /* Ensure button is always visible */
                .vs-btn.style-4 {
                    position: relative !important;
                    z-index: 1000 !important;
                    visibility: visible !important;
                    opacity: 1 !important;
                }
                
                @media (max-width: 768px) {
                    .vs-services-box-style1 {
                        margin-bottom: 20px;
                    }
                    .services-content {
                        padding: 20px !important;
                    }
                    .pt-120 {
                        padding-top: 60px !important;
                    }
                    .position-absolute.text-white-color {
                        font-size: 120px !important;
                        bottom: -20px !important;
                    }
                    
                    /* Mobile button styling */
                    .vs-btn.style-4 {
                        padding: 14px 25px !important;
                        font-size: 14px !important;
                        display: block !important;
                        margin: 20px auto !important;
                        width: fit-content !important;
                    }
                }
            `}</style>
        </>
    );
};

export default Services;